module.exports = __webpack_public_path__ + "img/95.9d7f345d.png";